import { PureComponent } from 'react';
import { connect } from 'react-redux';
import CategorySeo from './CategorySeo.component';

export const mapStateToProps = state => ({
    seoText: state.CategoryReducer.category.seo_text
});

class CategorySeoContainer extends PureComponent {
    render() {
        return <CategorySeo { ...this.props } />;
    }
}

export default connect(mapStateToProps, null)(CategorySeoContainer);
